export const siteInfo = {
  name: '瓜田吃瓜',
  slogan: '吃瓜不只八卦，更是一场围观心理学',
  intro:
    '我们收集那些让人停不下来的围观瞬间，配上一点心理学、一点冷知识，再加一勺段子和表情包。看完你会明白：吃瓜的快乐，其实有迹可循。',
  email: 'hello@gutianchigua.com',
};

export const navItems = [
  { id: 'hot', label: '今日瓜田' },
  { id: 'psych', label: '吃瓜心理' },
  { id: 'facts', label: '冷知识' },
  { id: 'jokes', label: '段子' },
  { id: 'memes', label: '表情包' },
  { id: 'categories', label: '分类' },
  { id: 'faq', label: '常见问题' },
  { id: 'about', label: '关于我们' },
];

export const heroStats = [
  { value: '30+', label: '每日新增瓜点' },
  { value: '520+', label: '围观冷知识' },
  { value: '1200+', label: '可保存表情包' },
  { value: '96%', label: '读者表示越吃越饿' },
];

export const hotMelons = [
  {
    id: 'hot-1',
    tag: '社交观察',
    title: '群聊里被撤回的那条消息，为什么最让人心痒',
    excerpt:
      '一条消息撤回后，群里瞬间安静了三秒，然后私聊窗口开始疯狂闪动。信息缺口一旦出现，大脑就会自动开始补全剧情。',
    heat: '9.8万人在围观',
    readTime: '3 分钟',
    image:
      'https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20a%20phone%20chat%20screen%20with%20speech%20bubbles%20and%20a%20recalled%20message%20icon%2C%20warm%20cream%20background%2C%20soft%20green%20and%20coral%20accent%20colors%2C%20playful%20editorial%20style&width=800&height=600&seq=guitian-hot-01&orientation=landscape',
  },
  {
    id: 'hot-2',
    tag: '办公室',
    title: '一句「你听说了吗」，如何点燃整层楼的好奇心',
    excerpt:
      '下午三点，茶水间门口聚集了四个人，声音压得很低。三十分钟后，这条消息已经走完了整层楼的工位。',
    heat: '7.4万人在围观',
    readTime: '4 分钟',
    image:
      'https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20an%20office%20pantry%20with%20three%20people%20whispering%20and%20coffee%20cups%2C%20warm%20cream%20background%2C%20soft%20green%20and%20coral%20accents%2C%20cheerful%20minimal%20style&width=800&height=600&seq=guitian-hot-02&orientation=landscape',
  },
  {
    id: 'hot-3',
    tag: '情绪过山车',
    title: '热搜反转又反转，围观群众的心情是怎么坐过山车的',
    excerpt:
      '第一波愤怒，第二波质疑，第三波"我早就觉得不对"。反转带来的不是疲惫，而是一种上瘾般的期待。',
    heat: '12.6万人在围观',
    readTime: '5 分钟',
    image:
      'https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20a%20rollercoaster%20made%20of%20speech%20bubbles%20with%20tiny%20people%2C%20warm%20cream%20background%2C%20soft%20green%20and%20coral%20palette%2C%20playful%20conceptual%20style&width=800&height=600&seq=guitian-hot-03&orientation=landscape',
  },
  {
    id: 'hot-4',
    tag: '传播链',
    title: '朋友的朋友的瓜，为什么传得比外卖还快',
    excerpt:
      '"我有一个朋友"开头的故事，往往传播速度惊人。因为距离感刚刚好，既刺激又不用负责。',
    heat: '5.9万人在围观',
    readTime: '3 分钟',
    image:
      'https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20a%20chain%20of%20connected%20people%20passing%20a%20speech%20bubble%2C%20warm%20cream%20background%2C%20soft%20green%20and%20coral%20tones%2C%20clean%20conceptual%20style&width=800&height=600&seq=guitian-hot-04&orientation=landscape',
  },
  {
    id: 'hot-5',
    tag: '深夜时刻',
    title: '深夜刷到旧动态，手指悬在屏幕上的那三秒',
    excerpt:
      '凌晨一点，自控力下线，好奇心上线。你点进去之前，其实已经知道自己会睡不着。',
    heat: '8.1万人在围观',
    readTime: '4 分钟',
    image:
      'https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20a%20person%20under%20a%20blanket%20at%20night%20scrolling%20a%20glowing%20phone%2C%20warm%20cream%20and%20deep%20green%20background%2C%20coral%20glow%20accents%2C%20cozy%20minimal%20style&width=800&height=600&seq=guitian-hot-05&orientation=landscape',
  },
  {
    id: 'hot-6',
    tag: '人情账',
    title: '家族群那句「帮忙点一下」，背后藏着多少人情往来',
    excerpt:
      '一个链接，两种心情。发的人觉得顺手，收的人却在心里盘算：这个忙，值不值得接。',
    heat: '4.3万人在围观',
    readTime: '3 分钟',
    image:
      'https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20hands%20exchanging%20small%20gift%20cards%20and%20a%20link%20icon%2C%20warm%20cream%20background%2C%20soft%20green%20and%20amber%20accents%2C%20friendly%20minimal%20style&width=800&height=600&seq=guitian-hot-06&orientation=landscape',
  },
];

export const psychologyPoints = [
  {
    id: 'psy-1',
    icon: 'ri-question-mark',
    title: '好奇缺口',
    desc: '信息越不完整，大脑越想把它补全。一条被撤回的消息，比十条完整消息更让人惦记。',
  },
  {
    id: 'psy-2',
    icon: 'ri-share-forward-line',
    title: '社交货币',
    desc: '知道一点别人不知道的事，聊天时就有了底气。分享信息，本质上是在交换关系。',
  },
  {
    id: 'psy-3',
    icon: 'ri-emotion-happy-line',
    title: '情绪代偿',
    desc: '看别人的戏剧性瞬间，能帮我们释放自己的压力。围观是一种低成本的情绪出口。',
  },
  {
    id: 'psy-4',
    icon: 'ri-group-line',
    title: '群体归属',
    desc: '一起围观同一件事，陌生人也瞬间有了共同话题。吃瓜是一种临时的团队建设。',
  },
  {
    id: 'psy-5',
    icon: 'ri-scales-3-line',
    title: '道德快感',
    desc: '站在旁观席上做出评判，会带来一丝轻微的优越感。这也是围观让人上瘾的原因之一。',
  },
  {
    id: 'psy-6',
    icon: 'ri-shield-star-line',
    title: '安全距离',
    desc: '别人的故事，自己不用承担后果。零风险的参与感，让吃瓜格外轻松。',
  },
];

export const coldFacts = [
  {
    id: 'fact-1',
    category: '大脑',
    text: '大脑处理「八卦信息」时激活的区域，和它处理食物、金钱奖励的区域高度接近。',
  },
  {
    id: 'fact-2',
    category: '社交',
    text: '同一件事，负面版本的传播速度平均比正面版本快不少，因为负面信息更容易被记住。',
  },
  {
    id: 'fact-3',
    category: '社交',
    text: '交换一次有效的小道消息，能让两个陌生人的心理距离明显缩短，效果堪比一次共同经历。',
  },
  {
    id: 'fact-4',
    category: '大脑',
    text: '听八卦时，大脑会释放少量多巴胺。这解释了为什么你刷完一条还会想刷下一条。',
  },
  {
    id: 'fact-5',
    category: '大脑',
    text: '被告知「这件事不太方便说」之后，大脑会自动高估这条信息的价值。',
  },
  {
    id: 'fact-6',
    category: '情绪',
    text: '看到别人出糗时，大脑会短暂激活与「自我感觉良好」相关的区域，这是一种保护性比较。',
  },
  {
    id: 'fact-7',
    category: '情绪',
    text: '深夜更容易被八卦吸引，因为这个时段的自我控制能力处在一天中的低谷。',
  },
  {
    id: 'fact-8',
    category: '冷门',
    text: '在团队中，适度参与非恶意闲聊的人，反而更容易被认为值得信任。',
  },
];

export const funnyQuotes = [
  { id: 'joke-1', text: '我妈让我别整天吃瓜，然后自己把家族群的语音听了三遍。', tag: '家庭' },
  { id: 'joke-2', text: '我不是爱看热闹，我只是对信息的完整性有执着的追求。', tag: '自嘲' },
  { id: 'joke-3', text: '吃瓜第一原则：先别下结论。第二原则：先转发给三个人，再一起下结论。', tag: '围观' },
  { id: 'joke-4', text: '别人的人生是连续剧，我的人生是花絮，还经常卡在片头。', tag: '自嘲' },
  { id: 'joke-5', text: '我的信息茧房里，塞满了别人的瓜，一个自己的都没有。', tag: '互联网' },
  { id: 'joke-6', text: '成年人的崩溃是静音的，成年人的吃瓜是外放的。', tag: '生活' },
  { id: 'joke-7', text: '每次我说「这是最后一个瓜」，朋友圈就会准时更新。', tag: '围观' },
  { id: 'joke-8', text: '好奇心害死猫，但猫有九条命，而我有 Wi-Fi。', tag: '互联网' },
];

export const memes = [
  {
    id: 'meme-1',
    caption: '假装不在意，耳朵却很诚实',
    tag: '围观中',
    image:
      'https://readdy.ai/api/search-image?query=Cute%20mascot%20character%20covering%20face%20but%20peeking%20through%20fingers%2C%20flat%20vector%20sticker%2C%20warm%20cream%20background%2C%20soft%20green%20and%20coral%20colors&width=600&height=600&seq=guitian-meme-01&orientation=squarish',
  },
  {
    id: 'meme-2',
    caption: '我已经准备好小板凳了',
    tag: '准备开瓜',
    image:
      'https://readdy.ai/api/search-image?query=Cute%20mascot%20sitting%20on%20a%20tiny%20stool%20with%20a%20watermelon%20slice%20and%20popcorn%2C%20flat%20vector%20sticker%2C%20warm%20cream%20background%2C%20soft%20green%20and%20coral%20colors&width=600&height=600&seq=guitian-meme-02&orientation=squarish',
  },
  {
    id: 'meme-3',
    caption: '信息量太大，我先坐一会儿',
    tag: '震惊',
    image:
      'https://readdy.ai/api/search-image?query=Cute%20mascot%20character%20with%20wide%20shocked%20eyes%20and%20swirl%20above%20head%2C%20flat%20vector%20sticker%2C%20warm%20cream%20background%2C%20soft%20green%20and%20coral%20colors&width=600&height=600&seq=guitian-meme-03&orientation=squarish',
  },
  {
    id: 'meme-4',
    caption: '冷静，我们理性吃瓜',
    tag: '理性派',
    image:
      'https://readdy.ai/api/search-image?query=Cute%20mascot%20wearing%20glasses%20holding%20a%20magnifying%20glass%20inspecting%20a%20watermelon%2C%20flat%20vector%20sticker%2C%20warm%20cream%20background%2C%20soft%20green%20and%20coral%20colors&width=600&height=600&seq=guitian-meme-04&orientation=squarish',
  },
  {
    id: 'meme-5',
    caption: '消息发出去三秒，我就后悔了',
    tag: '撤回现场',
    image:
      'https://readdy.ai/api/search-image?query=Cute%20mascot%20character%20reaching%20to%20undo%20a%20message%20bubble%20in%20panic%2C%20flat%20vector%20sticker%2C%20warm%20cream%20background%2C%20soft%20green%20and%20coral%20colors&width=600&height=600&seq=guitian-meme-05&orientation=squarish',
  },
  {
    id: 'meme-6',
    caption: '今日份快乐已到账',
    tag: '心满意足',
    image:
      'https://readdy.ai/api/search-image?query=Cute%20happy%20mascot%20hugging%20a%20big%20watermelon%20slice%20with%20sparkles%2C%20flat%20vector%20sticker%2C%20warm%20cream%20background%2C%20soft%20green%20and%20coral%20colors&width=600&height=600&seq=guitian-meme-06&orientation=squarish',
  },
];

export const categories = [
  {
    id: 'cat-psych',
    name: '吃瓜心理',
    icon: 'ri-mental-health-line',
    desc: '拆解围观背后的心理机制，看懂自己为什么会点开那条消息。',
    count: 128,
  },
  {
    id: 'cat-facts',
    name: '围观冷知识',
    icon: 'ri-lightbulb-flash-line',
    desc: '关于八卦、传播和记忆的冷门研究，聊天时随手就能用。',
    count: 96,
  },
  {
    id: 'cat-jokes',
    name: '日常段子',
    icon: 'ri-chat-smile-2-line',
    desc: '把生活的鸡毛蒜皮写成一句好笑的总结，看完想转发给三个人。',
    count: 214,
  },
  {
    id: 'cat-memes',
    name: '表情包',
    icon: 'ri-emotion-laugh-line',
    desc: '高共鸣的表情包合集，聊天没词的时候，它们替你说话。',
    count: 360,
  },
  {
    id: 'cat-guide',
    name: '围观指南',
    icon: 'ri-compass-3-line',
    desc: '怎么吃瓜才不掉坑：识别信息、保持距离、别急着站队。',
    count: 72,
  },
  {
    id: 'cat-mood',
    name: '情绪观察',
    icon: 'ri-heart-pulse-line',
    desc: '记录那些被瓜牵动的心情起伏，顺便练习和自己的情绪相处。',
    count: 84,
  },
];

export const faqs = [
  {
    id: 'faq-1',
    q: '瓜田吃瓜到底在讲什么？',
    a: '我们围绕「吃瓜」这件事做内容：一边更新日常段子与表情包，一边用心理学和冷知识解释围观时的心态变化。目标是让你看得开心，也看得明白。',
  },
  {
    id: 'faq-2',
    q: '这里的内容是每天更新的吗？',
    a: '是的。今日瓜田、冷知识和段子会持续补充，表情包也会定期上新。你随时回来，基本都能刷到新的东西。',
  },
  {
    id: 'faq-3',
    q: '你们会讨论真实的人物和事件吗？',
    a: '我们更关注普遍的社会情境与心理机制，比如群聊、办公室、家族群里的围观现象，而不是去评判具体的人。理性吃瓜，是我们一直强调的态度。',
  },
  {
    id: 'faq-4',
    q: '表情包可以直接保存使用吗？',
    a: '站内的表情包都可以保存下来自用，用于日常聊天没问题。如果你打算用于商业场景，请先通过页脚邮箱和我们联系。',
  },
  {
    id: 'faq-5',
    q: '怎么才能不掉进「越吃越焦虑」的坑？',
    a: '我们的建议是三步：先确认信息是否完整、给自己设一个围观时限、最后把注意力还给自己的生活。围观指南分类里有更详细的方法。',
  },
  {
    id: 'faq-6',
    q: '可以投稿自己的段子或者瓜田故事吗？',
    a: '非常欢迎。你可以把内容发到页脚的邮箱，注明是否可以公开展示。被选中的内容我们会在站内标注来源。',
  },
];

export const testimonials = [
  {
    id: 't-1',
    name: '小满',
    role: '通勤刷手机重度用户',
    text: '以前只觉得吃瓜是浪费时间，看完这里的心理分析，才知道自己是在找一个情绪出口。',
  },
  {
    id: 't-2',
    name: '阿吉',
    role: '办公室气氛组成员',
    text: '冷知识那部分简直是我的聊天弹药库，一句「大脑处理八卦的方式和食物很像」就能开场。',
  },
  {
    id: 't-3',
    name: '林间',
    role: '表情包收藏家',
    text: '表情包的画风很统一，存了一整套，聊天时用起来特别顺，不用再翻遍相册找图。',
  },
  {
    id: 't-4',
    name: '一碗汤',
    role: '深夜冲浪选手',
    text: '最喜欢那句「成年人的吃瓜是外放的」，看完笑了一下，也顺手放下了手机去睡觉。',
  },
];